export var Theme;
(function (Theme) {
    Theme["default"] = "default";
    Theme["light"] = "light";
    Theme["dark"] = "dark";
    Theme["mint"] = "mint";
    Theme["green"] = "green";
    Theme["peach"] = "peach";
    Theme["lavender"] = "lavender";
    Theme["blonde"] = "blonde";
})(Theme || (Theme = {}));
export var ThemeColor;
(function (ThemeColor) {
    ThemeColor["lightGray"] = "#dcdcdc";
    ThemeColor["darkGray"] = "#464646";
    ThemeColor["lightBlack"] = "#1C1D1C";
    ThemeColor["lightGreen"] = "#75B680";
    ThemeColor["mint"] = "#bce0c7";
    ThemeColor["green"] = "#364239";
    ThemeColor["peach"] = "#f5d4d2";
    ThemeColor["lavender"] = "#dbccf3";
    ThemeColor["blonde"] = "#ffebB8";
    ThemeColor["white"] = "white";
    ThemeColor["black"] = "black";
})(ThemeColor || (ThemeColor = {}));
export var Size;
(function (Size) {
    Size["small"] = "small";
    Size["medium"] = "medium";
    Size["large"] = "large";
})(Size || (Size = {}));
export var FollowModules;
(function (FollowModules) {
    FollowModules["FeeFollowModule"] = "FeeFollowModule";
    FollowModules["ProfileFollowModule"] = "ProfileFollowModule";
    FollowModules["RevertFollowModule"] = "RevertFollowModule";
    FollowModules["UnknownFollowModule"] = "UnknownFollowModule";
})(FollowModules || (FollowModules = {}));
//# sourceMappingURL=types.js.map